import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../_common/Loader/Loader';
import Table from '../../../../_common/Tables/Table';
import classes from '../../dashboard.module.scss';
import Api from '../../../../../api/api';
import Button from '../../../../_common/Form/Buttons/Button';
import { useQuery } from '../../../../../utils/hooks/useQuery';

const STATUS_STYLES = {
  'On Track': { background: '#DCFCE7', color: '#16A34A' },
  'At Risk': { background: '#FEF9C3', color: '#CA8A04' },
  'Intervention Needed': { background: '#FEE2E2', color: '#DC2626' },
};

const TABLE_HEADER = [
  { name: 'Patient', path: 'patient' },
  { name: 'Drug', path: 'drug' },
  { name: 'PDC', path: 'pdcPct' },
  { name: 'MPR', path: 'mprPct' },
  { name: 'Gap days', path: 'gapDays' },
  { name: 'Status', path: 'statusBadge' },
];

export const buildAdherenceTableRows = (rows) => rows.map((r) => {
  const style = STATUS_STYLES[r.adherenceStatus] ?? { background: '#F3F4F6', color: '#374151' };

  return {
    ...r,
    id: r.patientId,
    statusBadge: (
      <span style={{
        ...style,
        padding: '2px 10px',
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        display: 'inline-block',
      }}
      >
        {r.adherenceStatus}
      </span>
    ),
  };
});

const PatientAdherenceTable = ({ requestData }) => {
  const navigate = useNavigate();

  const { query, queryToStringify } = useQuery();

  const [patientAdherenceData, setPatientAdherenceData] = useState([]);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getPatientAdherence(requestData);

        setPatientAdherenceData(data.data || []);
        loadingToggle(false);
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [requestData]);

  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 12,
        padding: 16,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
      className={classes.chart_kpi_wrapper}
    >
      <p style={{
        margin: '0 0 12px',
        fontWeight: 700,
        fontSize: 15,
        color: '#111827',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
      >
        Patient adherence overview

        {!!patientAdherenceData.length && !loading && (
          <Button
            title="View all"
            href={`/dashboard/patient-adherence${queryToStringify(query)}`}
            className={classes.view_all}
          />
        )}
      </p>

      {loading
        ? <Loader className={classes.chart_kpi_wrapper_loader} />

        : (
          <Table
            data={buildAdherenceTableRows(patientAdherenceData)}
            header={TABLE_HEADER}
            className={classes.clickable_row}
            onClick={(patientId) => navigate(`/patients/${patientId}`)}
          />
        )}
    </div>
  );
};

export default PatientAdherenceTable;
